import { useState } from 'react';
import { TRACKING } from 'common/constants/constants';
import { PM_METRICS_DEFINITION } from './usePMConfig';
import {
  FEATURE_FLAGS_NAMES,
  MTTR_STRATEGY,
  CFR_INCIDENT_STRATEGY
} from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import _ from 'lodash';

export const useIncidentsConfig = ({
  PMConfig,
  PMMetric,
  parentConfiguration,
  isUsingParentConfig
}) => {
  const relevantConfig = isUsingParentConfig ? parentConfiguration : PMConfig;

  const [incidentStrategy, setIncidentStrategy] = useState(null);
  const [incidentConfig, setIncidentConfig] = useState(
    PM_METRICS_DEFINITION[PMMetric].default_incident_config
  );

  const { getSettingOrDefinitionValue } = useSettingsService();
  const isMTTRDurationEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isMTTRDurationEnabled
  });

  const validateincidentConfig = (
    PMMetric,
    incidentConfig,
    incidentStrategy
  ) => {
    if (
      incidentStrategy === MTTR_STRATEGY.STATE_TRANSITION ||
      incidentStrategy === CFR_INCIDENT_STRATEGY.STATE
    ) {
      return true;
    }
    if (!incidentConfig) return false;
    return PMMetric === TRACKING.PAGE_TABS.MTTR
      ? !!incidentConfig.to && !!incidentConfig.from
      : !!incidentConfig.value;
  };

  const initIncidentsConfig = () => {
    const incidentStrategy = _.get(
      relevantConfig,
      `incident_strategy_config.strategy`,
      PMMetric === TRACKING.PAGE_TABS.MTTR
        ? MTTR_STRATEGY.STATE_TRANSITION
        : CFR_INCIDENT_STRATEGY.STATE
    );
    const incidentConfig = _.get(
      relevantConfig,
      `incident_strategy_config.config`,
      PM_METRICS_DEFINITION[PMMetric].default_incident_config
    );
    return { incidentConfig, incidentStrategy };
  };

  const shouldAddIncidentToConfig =
    isMTTRDurationEnabled &&
    (incidentStrategy === MTTR_STRATEGY.CUSTOM_FIELD_TRANSITION ||
      incidentStrategy === CFR_INCIDENT_STRATEGY.CUSTOM_FIELD);

  return {
    initIncidentsConfig,
    incidentConfig,
    setIncidentConfig,
    incidentStrategy,
    setIncidentStrategy,
    shouldAddIncidentToConfig,
    validateincidentConfig
  };
};
